export default __webpack_public_path__ + "static/media/books.b8b41b22.svg";